import { useAgTechAuthContext } from "@agtech/core/auth/AgTechAuthContext";
import AgTechHeaderUserDetail from "../../../integrations/users/widgets/AgTechHeaderUserDetail";

const AgTechLandingPageHeader = () => {
    const authContext = useAgTechAuthContext();

    return (
        <div className='h-[64px] wide column-based px-[24px] items-center container'>
            <h1 className='font-orbitron text-white text-2xl'>
                Dakota Agtech
            </h1>
            {authContext.isUserAuthenticated() ? (
                <div className='ml-auto flex'>
                    <AgTechHeaderUserDetail
                        settings={{
                            header: {
                                classes: 'text-white'
                            },
                            detail: {
                                classes: 'text-white'
                            }
                        }}
                    />
                </div>
            ) : (
                <div className='column-based ml-auto container'>
                    <button
                        className='bg-transparent bordered rounded py-2 clickable text-base text-white font-bold mr-6'
                        style={{ width: 120 }}
                        onClick={() => {
                            authContext.loginUser();
                        }}
                    >
                        Sign In
                    </button>
                    <button
                        className='bg-highlight-600 border border-highlight rounded py-2 clickable text-base font-semibold text-white'
                        style={{ width: 120 }}
                        onClick={() => {
                            authContext.loginUser();
                        }}
                    >
                        Sign Up
                    </button>
                </div>
            )}
        </div>
    )
}

export default AgTechLandingPageHeader;